import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMetric, unSelectMetric } from '@store/aiAlerts/summary/actions';
import { aiAlertsMetricsMetaSelector } from '@store/common/selectors';
import { selectedMetricsSelector } from '@store/aiAlerts/summary/selectors';
import { Wrapper, MetricTagName, MetricTagValue } from './styled';

const MetricTag = ({ tag, value }) => {
  const dispatch = useDispatch();
  const selectedTags = useSelector(selectedMetricsSelector);
  const aiAlertsMetricsMeta = useSelector(aiAlertsMetricsMetaSelector);
  const isSelected = selectedTags.includes(tag.pulse4Key);

  const onClickOfTag = () => {
    if (isSelected) {
      dispatch(unSelectMetric(tag.pulse4Key));
    } else {
      dispatch(selectMetric(tag.pulse4Key));
    }
  };
  const metricInfo = aiAlertsMetricsMeta.find((metric) => metric.pulse4Key === tag.pulse4Key);
  return (
    <Wrapper isSelected={isSelected} onClick={onClickOfTag}>
      <MetricTagName>{metricInfo?.shortName}</MetricTagName>
      <MetricTagValue>{value}</MetricTagValue>
    </Wrapper>
  );
};

export default MetricTag;
